<script>
	const products = [
		{
			brand: 'Dermalogica',
			name: 'Acne Clearing Skin Wash',
			type: 'Cleanser',
			rating: '★★★★☆',
			ratingText: '4.6 (555)',
			price: '$44',
			match: '95% Match',
			concerns: ['oily skin', 'acne']
		},
		{
			brand: 'Kate Somerville',
			name: 'Line Release Under Eye Cream',
			type: 'Eye Cream',
			rating: '★★★★☆',
			ratingText: '3.9 (71)',
			price: '$140',
			match: '88% Match',
			concerns: ['wrinkles', 'under eye']
		},
		{
			brand: 'Fresh',
			name: 'Black Tea Anti-Aging Moisturizer',
			type: 'Moisturizer',
			rating: '★★★★★',
			ratingText: '4.8 (1424)',
			price: '$95',
			match: '92% Match',
			concerns: ['dry skin', 'wrinkles']
		}
	];
</script>

<section class="section">
	<div class="inner">
		<p class="section-label">Your Routine</p>
		<h2 class="section-title">Curated For You</h2>
		<p class="sample-note">Example products. Match scores are illustrative, not yours.</p>
		<div class="products-grid">
			{#each products as product}
				<div class="product-card">
					<div class="product-brand">{product.brand}</div>
					<div class="product-name">{product.name}</div>
					<div class="product-type">{product.type}</div>
					<div class="rating">
						<span class="stars">{product.rating}</span>
						<span class="rating-text">{product.ratingText}</span>
					</div>
					<div class="product-price">{product.price}</div>
					<span class="match-badge">{product.match}</span>
					<div class="concern-pills">
						{#each product.concerns as concern}
							<span class="concern-pill">{concern}</span>
						{/each}
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>

<style>
	.section {
		padding: var(--section-gap) var(--page-pad-x);
		background: var(--surface);
	}

	.inner {
		max-width: var(--content-max);
		margin: 0 auto;
	}

	/* The shared .section-title parks --section-gap below itself, which
	   double-counts against this section's own --section-gap padding. Type,
	   colour and alignment stay from the primitive; only the trailing space
	   is re-parked, identically in all four landing sections. */
	.section-title {
		margin-bottom: var(--space-12);
	}

	/* Required labelling for fabricated data. Kept at body size. */
	.sample-note {
		max-width: var(--prose-max);
		margin: 0 auto var(--space-6);
		text-align: center;
		font-size: var(--text-sm);
		line-height: var(--leading-normal);
		color: var(--text-muted);
	}

	.products-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
		gap: var(--space-px);
		background: var(--border);
	}

	.product-card {
		background: var(--surface);
		padding: var(--card-pad);
		transition: background var(--transition);
	}

	.product-card:hover {
		background: var(--surface-2);
	}

	.product-brand {
		font-size: var(--text-3xs);
		letter-spacing: var(--track-eyebrow);
		text-transform: uppercase;
		color: var(--rose);
		margin-bottom: var(--space-3);
	}

	.product-name {
		font-family: var(--font-display);
		font-size: var(--text-xl);
		font-weight: var(--weight-regular);
		line-height: var(--leading-snug);
		color: var(--cream);
		margin-bottom: var(--space-3);
	}

	.product-type {
		font-size: var(--text-xs);
		letter-spacing: var(--track-label);
		text-transform: uppercase;
		color: var(--text-muted);
		margin-bottom: var(--space-5);
	}

	.rating {
		display: flex;
		align-items: center;
		gap: var(--space-2);
		margin-bottom: var(--space-4);
	}

	.stars {
		color: var(--rose);
		font-size: var(--text-xs);
		letter-spacing: var(--track-label);
	}

	.rating-text {
		font-size: var(--text-xs);
		color: var(--text-muted);
	}

	.product-price {
		font-size: var(--text-xl);
		font-weight: var(--weight-light);
		color: var(--cream);
		margin-bottom: var(--space-5);
	}

	.match-badge {
		display: inline-block;
		padding: var(--space-1) var(--space-4);
		background: var(--rose-veil);
		border: 1px solid var(--rose-line);
		border-radius: var(--radius-0);
		color: var(--rose);
		font-size: var(--text-2xs);
		font-weight: var(--weight-medium);
		letter-spacing: var(--track-label);
	}

	.concern-pills {
		display: flex;
		flex-wrap: wrap;
		gap: var(--space-1);
		margin-top: var(--space-5);
	}

	.concern-pill {
		padding: var(--space-1) var(--space-3);
		background: var(--hover-veil);
		border: 1px solid var(--border);
		border-radius: var(--radius-0);
		color: var(--text-muted);
		font-size: var(--text-3xs);
		letter-spacing: var(--track-label);
		text-transform: uppercase;
	}
</style>
